import { ParentType } from '../types/enum/parent-types';
import React from 'react';

export const ParentContext = React.createContext<ParentType | undefined>(undefined);